import React from "react";
import { Slider } from "@/components/ui/slider";

export const DIALS = [
  { key: "objection_level", label: "Objection level", lo: "Easy-going", hi: "Relentless" },
  { key: "budget", label: "Budget", lo: "Tight", hi: "Generous" },
  { key: "attitude", label: "Attitude", lo: "Hostile", hi: "Warm" },
];

export const DEFAULT_DIALS = { objection_level: 5, budget: 5, attitude: 5 };

export function DialSliders({ values, onChange, idPrefix = "dial" }) {
  return (
    <div className="space-y-4">
      {DIALS.map((d) => (
        <div key={d.key} data-testid={`${idPrefix}-${d.key}`}>
          <div className="flex items-center justify-between text-xs">
            <span className="font-medium text-slate-700">{d.label}</span>
            <span className="font-mono text-emerald-600" data-testid={`${idPrefix}-${d.key}-value`}>{values[d.key]}/10</span>
          </div>
          <Slider value={[values[d.key]]} min={1} max={10} step={1}
            onValueChange={([v]) => onChange({ ...values, [d.key]: v })} className="mt-2" />
          <div className="flex justify-between text-[10px] text-slate-400 mt-1"><span>{d.lo}</span><span>{d.hi}</span></div>
        </div>
      ))}
    </div>
  );
}

export function DialChips({ persona }) {
  const set = DIALS.filter((d) => persona[d.key] != null);
  if (!set.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5 mt-2" data-testid="dial-chips">
      {set.map((d) => (
        <span key={d.key} className="text-[10px] px-2 py-0.5 rounded-full bg-emerald-500/10 text-emerald-700 border border-emerald-500/20 font-mono">
          {d.label.split(" ")[0]} {persona[d.key]}/10
        </span>
      ))}
    </div>
  );
}
